<template>
    <div id="modelOverview">
        <v-toolbar light flat color="grey lighten-4">
            <v-spacer/>
            <v-btn v-if="!readonly" color="light-green" @click="save" dark>Save</v-btn>
        </v-toolbar>
        <v-container fluid>
            <v-row>
                <v-col cols="7">
                    <v-row>
                        <v-col cols="2">
                            <h3>Booking Details</h3>
                        </v-col>
                        <v-col cols="10">
                            <div class="BookingContactForm">
                                <v-form>

                                    <v-text-field
                                            v-model="model.courseTitle"
                                            label="Course Title"
                                            :readonly="readonly"
                                    ></v-text-field>
                                    <DatePicker
                                        v-model="model.bookingDate"
                                        label="Booking Date"
                                        :readonly="readonly"
                                    />
                                    <DatePicker
                                        v-model="model.firstDeliveryDate"
                                        label="First Delivery Date"
                                        :readonly="readonly"
                                    />

                                    <AccountManager
                                            v-model="model.accountManager"
                                            @selected="updateAccountManager"

                                    />
                                    <v-row>
                                        <v-col cols="6">
                                            <TypeSelector
                                                    v-model="model.trainingType"
                                                    label="Training Type *"
                                                    type="training"
                                                    :readonly="readonly"
                                            />
                                        </v-col>
                                        <v-col cols="6">
                                            <TypeSelector
                                                    v-model="model.bookingType"
                                                    label="Booking Type *"
                                                    :readonly="readonly"
                                            />
                                        </v-col>
                                    </v-row>
                                    <CraftSearch v-model="model.craftId" />
                                </v-form>
                            </div>
                        </v-col>

                    </v-row>
                    <v-row>
                        <v-col cols="2">
                            <h3>Booker</h3>
                        </v-col>
                        <v-col cols="10">
                            <div class="BookingContactForm">
                                <BookerForm
                                    :model="model"
                                    :readonly="readonly"
                                />
                            </div>
                        </v-col>

                    </v-row>
                </v-col>
                <v-col cols="5">
                    <v-card>
                        <v-toolbar flat>
                            <v-toolbar-title>Customer</v-toolbar-title>
                        </v-toolbar>
                        <v-list-item>
                            <v-list-item-icon>
                                <v-icon>mdi-account</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{model.customer.contactName}}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-icon>
                                <v-icon>mdi-domain</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{model.customer.company}}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-card-actions>
                            <v-btn text color="primary" :to="{name: 'customer-view', params:{id: model.customer.id}}">View Customer</v-btn>
                        </v-card-actions>
                    </v-card>
                    <v-card class="mt-2">
                        <v-toolbar flat>
                            <v-toolbar-title>Notes</v-toolbar-title>

                        </v-toolbar>
                        <v-card-text>
                        <v-textarea
                                v-model="model.printedNotes"
                                label="Printed Notes"

                        />
                            <v-textarea
                                v-model="model.nonPrintedNotes"
                                label="Non-Printed Notes"

                        />
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>

</template>

<script>

    import BOOKING_DETAILS_UPDATE from "../../graphql/BookingDetailsUpdate.gql";
    import moment from "moment";
    import BookerForm from "./Forms/BookerForm";
    import AccountManager from "../AutoCompletes/AccountManager";
    import DatePicker from "../DatePicker";
    import TypeSelector from "../TypeSelector";
    import CraftSearch from "../AutoCompletes/CraftSearch";

    export default {
        components: {
            BookerForm,
            AccountManager,
            DatePicker,
            TypeSelector,
            CraftSearch,
        },
        props: {
            model: Object,
            readonly: {
                type: Boolean,
                default:false
            },
        },
        data() {
            return {
                id: parseInt(this.$route.params.id),
                tab: this.$route.query.tab,
                updating: false,
                pickerOpen: false,
            }
        },
        computed: {
            formattedBookingDate() {
                return moment(this.model.bookingDate).format("ddd, D MMMM YYYY");
            }

        },
        watch: {
            updating(val) {
                this.$emit('updating', val);
            }
        },
        methods: {
            updateAccountManager(accountManager){
                this.model.accountManager = accountManager
            },
            save() {
                this.updating = true
                this.$apollo.mutate({
                    mutation: BOOKING_DETAILS_UPDATE,
                    variables: {
                        input: {
                            id: this.model.id,
                            courseTitle: this.model.courseTitle,
                            bookingDate: this.model.bookingDate,
                            firstDeliveryDate: this.model.firstDeliveryDate,
                            accountManager: {connect: this.model.accountManager.id},
                            contactName: this.model.contactName,
                            contactCompany: this.model.contactCompany,
                            contactEmail: this.model.contactEmail,
                            contactAddress1: this.model.contactAddress1,
                            contactAddress2: this.model.contactAddress2,
                            contactAddress3: this.model.contactAddress3,
                            contactTown: this.model.contactTown,
                            contactCounty: this.model.contactCounty,
                            contactPostcode: this.model.contactPostcode,
                            contactPhone: this.model.contactPhone,
                            printedNotes: this.model.printedNotes,
                            nonPrintedNotes: this.model.nonPrintedNotes,
                            trainingType: this.model.trainingType,
                            craftId: this.model.craftId,
                        }
                    },
                }).then(() => {
                    this.updating = false
                    this.$emit('saved');
                    this.$store.dispatch('notification/addSuccess', 'Save successful')
                }).catch(({error}) => {
                    // Error
                    this.updating = false
                    this.$store.dispatch('notification/handleGraphQlError', error)
                })
            },

        }

    }


</script>